import { useEffect, useState } from 'react';
import { useFormContext } from '@stepform';
import type { IDeclaration } from '@stepform';

class MentalHealthFormDeclaration implements IDeclaration {
  public confirm = false;
  private showValidationMessage = false;

  public completed(): boolean {
    return this.confirm;
  }

  public validate(): void {
    this.showValidationMessage = !this.completed();
  }

  public showValidationMsg(): boolean {
    return this.showValidationMessage;
  }
}

export function MentalHealthDeclaration() {
  const { formService, forceUpdate } = useFormContext();
  const [declaration] = useState(() => {
    const decl = new MentalHealthFormDeclaration();
    formService.setDeclaration(decl);
    return decl;
  });

  useEffect(() => {
    if (declaration.confirm) {
      declaration.validate();
      forceUpdate();
    }
  }, [declaration.confirm, declaration, forceUpdate]);

  return (
    <div>
      <hr className="pull-right" />
      <div>
        <div className="stepform-question-wrapper" id="field-declaration-confirm">
          <div className="question table">
            <div className="help-toggle-wrapper"></div>
          </div>

          <div className="answer-group">
            <div className="answer">
              <input
                type="checkbox"
                checked={declaration.confirm}
                onChange={(e) => {
                  declaration.confirm = e.target.checked;
                  forceUpdate();
                }}
                name="declaration-confirm"
                id="declaration-confirm"
                required
              />
              <label htmlFor="declaration-confirm">
                The information I have provided is true and correct to the best of my knowledge and
                belief
              </label>
            </div>
          </div>

          <div
            className={`validation-msg${declaration.showValidationMsg() ? ' active' : ''}`}
            style={{ display: declaration.showValidationMsg() ? undefined : 'none' }}
          >
            Required
          </div>
        </div>
      </div>
    </div>
  );
}
